import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';

export default function Header({
  title,
  handleExport,
  handleRun,
  isFrr,
  hideExport = false,
  noMenuForExport,
  isFromCaseReport,
  isExporting = false,
}) {
  const menu = useRef(null);

  const items = [
    {
      label: 'Range',
      items: [
        {
          label: '12 Months Data',
          command: () => handleExport(12),
        },
        {
          label: '24 Months Data',
          command: () => handleExport(24),
        },
      ],
    },
  ];

  return (
    <div className="d-flex justify-content-between gap-2 mb-2 flex-wrap report-header">
      <h1 className="title gray-800 mb-0 fs-3 fs-md-1">{title}</h1>
      <div>
        <Menu model={items} popup ref={menu} id="popup_menu" />
        {Boolean(hideExport) === false && (
          <Button
            className="p-button p-button-primary outline"
            onClick={(event) => (isFrr && !noMenuForExport ? menu.current.toggle(event) : handleExport())}
            label={isFrr ? 'Export' : isFromCaseReport ? 'Export Data' : 'Export All Data'}
            tooltipOptions={{ position: 'left' }}
            icon="pi pi-download"
            tooltip={isFromCaseReport ? `Export filtered data` : isFrr ? '' : `All data will be exported. Filter won't apply.`}
          />
        )}
        <Button label="Run Report" className="p-button p-button-primary ms-2" onClick={handleRun} />
      </div>
    </div>
  );
}
